let settingsPromise; // Stores the promise for settings fetch

const getSettings = async () => {
    if (!settingsPromise) {
      
        settingsPromise = fetch("/settings.json").then((response) => response.json());
    }
    return settingsPromise;
};


export default getSettings;